// src/lib/edge.js
import { supabase } from "services/supabaseClient";

export async function callFunction(fnName, { body } = {}) {
  const { data, error } = await supabase.functions.invoke(fnName, { body });

  if (error) {
    const contextBody = error.context
      ? await error.context.clone().json().catch(() => null)
      : null;

    console.error(`[callFunction:${fnName}]`, {
      message: error.message,
      status: error.status,
      contextBody,
      body,
    });

    const message =
      contextBody?.message || contextBody?.error || error.message || "Request failed";
    const wrapped = new Error(message);
    wrapped.code = contextBody?.code || "EDGE_FUNCTION_ERROR";
    wrapped.status = error.status;
    wrapped.contextBody = contextBody;
    throw wrapped;
  }

  return data;
}
